import { render, staticRenderFns } from "./contentBox.vue?vue&type=template&id=4fc86f46"
import script from "./contentBox.vue?vue&type=script&lang=js"
export * from "./contentBox.vue?vue&type=script&lang=js"
import style0 from "./contentBox.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports